__turbopack_context__.v({
  "description": "aK0CYW_description",
  "figure": "aK0CYW_figure",
  "imageWrapper": "aK0CYW_imageWrapper",
  "timeAndPlace": "aK0CYW_timeAndPlace",
});
